import { FeaturePermissions } from '../../cmg-1003/models';
import { BusinessChannel } from '../../models';

export interface GetSecurityProfilesResponse {
  profiles: SecurityProfileModel[];
}

export interface SecurityProfileModel {
  organizationId: number;
  organizationName: string;
  securityProfileId: number;
  securityProfileName: string;
  userOrgProfileId: number;
  isAdmin: boolean;
  canAssignLoansToOrg: boolean;
  isBackgroundChecked: boolean;
  featurePermissions: FeaturePermissions;
  businessChannel: BusinessChannel;
  dailyRatesheetUrl: string;
  aioRatesheetUrl: string;
  userId: number;
  userName: string;
}

export enum SecurityProfileRole {
  AccountManager = 'AccountManager',
  Accounting = 'Accounting',
  AccountExecutive = 'AccountExecutive',
  Admin = 'Admin',
  APIAdmin = 'APIAdmin',
  AdminPurge = 'AdminPurge',
  AdminReporting = 'AdminReporting',
  AdminLaptop = 'AdminLaptop',
  LoanProcessor = 'LoanProcessor',
  Closer = 'Closer',
  DisclosureCoordinator = 'DisclosureCoordinator',
  Underwriter = 'Underwriter',
  Funder = 'Funder',
  Compliance = 'Compliance',
  Shipper = 'Shipper',
  LockDesk = 'LockDesk',
  Servicing = 'Servicing',
  Insuring = 'Insuring',
  Secondary = 'Secondary',
  JrAdministrator = 'JrAdministrator',
  TeamLead = 'TeamLead',
  PostCloserMERS = 'PostCloserMERS',
  PostClosingFlood = 'PostClosingFlood',
  PostClosingMI = 'PostClosingMI',
  Licensing = 'Licensing',
  Risk = 'Risk',
  CollateralSpecialist = 'CollateralSpecialist',
  JrAccountManager = 'JrAccountManager',
  ClientSuccessExpert = 'ClientSuccessExpert',
  WarehouseCoordinator = 'WarehouseCoordinator',
  LoanOfficer = 'LoanOfficer',
  RetailDisclosureCoordinator = 'RetailDisclosureCoordinator',
  SVP = 'SVP',
  WholesaleManager = 'WholesaleManager',
  WholesaleTeamLead = 'WholesaleTeamLead',
  Manager = 'Manager',
  ProductionAssistant = 'ProductionAssistant',
  RetailOpsManager = 'RetailOpsManager',
  WholesaleUnderwriter = 'WholesaleUnderwriter',
  RegistrationCoordinator = 'RegistrationCoordinator',
  ReDisclosureCoordinator = 'ReDisclosureCoordinator',
  Level3ExceptionsAndSecondReview = 'Level3ExceptionsAndSecondReview',
  QualityControl = 'QualityControl',
  AppraisalDesk = 'AppraisalDesk',
  ViewOnly = 'ViewOnly',
  JrUnderwriter = 'JrUnderwriter',
  Level1ExceptionsAndSecondReview = 'Level1ExceptionsAndSecondReview',
  WholesaleOpsManager = 'WholesaleOpsManager',
  CORRNationalSalesManager = 'CORRNationalSalesManager',
  CORRClientLiaison = 'CORRClientLiaison',
  CORRRegistrationCoordinator = 'CORRRegistrationCoordinator',
  CORRCreditAuditor = 'CORRCreditAuditor',
  CORRLegalAuditor = 'CORRLegalAuditor',
  CORRCollateralSpecialist = 'CORRCollateralSpecialist',
  CORRPurchaser = 'CORRPurchaser',
  Fraud = 'Fraud',
  CORRAdmin = 'CORRAdmin',
  SuperUser = 'SuperUser',
  CORRSuperUser = 'CORRSuperUser',
  LimitedAdmin = 'LimitedAdmin',
  Level2ExceptionsAndSecondReview = 'Level2ExceptionsAndSecondReview',
  RiskAdmin = 'RiskAdmin',
  CallCenterLO = 'CallCenterLO',
  JVLoanOfficer = 'JVLoanOfficer',
  JVLoanProcessor = 'JVLoanProcessor',
  JVProductionAssistant = 'JVProductionAssistant',
  JVManager = 'JVManager',
  UnreleasedUnderwriter = 'UnreleasedUnderwriter',
  RenovationsSpecialist = 'RenovationsSpecialist',
  Processor3 = 'Processor3',
  Processor2 = 'Processor2',
  REDLimitedAccess = 'REDLimitedAccess',
  LaptopSuperUser = 'LaptopSuperUser',
  JVOPSManager = 'JVOPSManager',
  Level4ExceptionsAndSecondReview = 'Level4ExceptionsAndSecondReview',
  ISGNRisk = 'ISGNRisk',
  ISGNAccountManager = 'ISGNAccountManager',
  ISGNAppraisalDesk = 'ISGNAppraisalDesk',
  ISGNCloser = 'ISGNCloser',
  ISGNFunder = 'ISGNFunder',
  ISGNInsuring = 'ISGNInsuring',
  ISGNPostCloserMERS = 'ISGNPostCloserMERS',
  ISGNPostClosingFlood = 'ISGNPostClosingFlood',
  ISGNPostClosingMI = 'ISGNPostClosingMI',
  ISGNQualityControl = 'ISGNQualityControl',
  ISGNRegCoordinator = 'ISGNRegCoordinator',
  ISGNServicing = 'ISGNServicing',
  ISGNShipper = 'ISGNShipper',
  ISGNCORRCreditAuditor = 'ISGNCORRCreditAuditor',
  ISGNCORRLegalAuditor = 'ISGNCORRLegalAuditor',
  ISGNCORRRegCoordinator = 'ISGNCORRRegCoordinator',
  ISGNTest = 'ISGNTest',
  ISGNProcessor = 'ISGNProcessor',
  REDLimitedAdmin = 'REDLimitedAdmin',
  Test = 'Test',
  Private = 'Private',
  BBLoanOfficer = 'BBLoanOfficer',
  BBUnderwriter = 'BBUnderwriter',
  BBRetailOpsManager = 'BBRetailOpsManager',
  SeniorOpsManager = 'SeniorOpsManager',
  WholesaleJRUW = 'WholesaleJRUW',
  ConstToPerm = 'ConstToPerm',
  DisclosureLO = 'DisclosureLO',
  SuperDisclosureLO = 'SuperDisclosureLO',
  SuperDisclosureLORelo = 'SuperDisclosureLORelo',
  PA2 = 'PA2',
  PA2LE = 'PA2LE',
  DisclosurePA = 'DisclosurePA',
  SuperDisclosurePA = 'SuperDisclosurePA',
  SupportAdmin = 'SupportAdmin',
}
